import React from "react";

type Props = {
  price: number;
};
const WalletPayment: React.FC<Props> = ({ price }) => {
  return (
    <div className="flex flex-col gap-2 items-center justify-center text-white">
      <p>
        قيمة المبلغ{" "}
        <span className="font-bold text-lg text-primaryColor">
          {price ? price : "0"}
        </span>{" "}
        جنيه
      </p>
      <p>سيتم خصم المبلغ من الرصيد الموجود في المحفظة</p>
    </div>
  );
};

export default WalletPayment;
